/**
 * Prevents long strings of text from wrapping
 * after short words which is unacceptable in text design
 */

const replaceShort = string =>
  string.replace
    ? string.replace(
        /\s(a|i|aj|o|u|and|or|for|the|in|at|of|on|&|s|k|z|v)\s/gi,
        ' $1\xa0'
      )
    : string;

export default replaceShort;



// WEBPACK FOOTER //
// ./src/scripts/lib/stringHandling.js